import React from 'react';
import style from './PageHeader.module.css';

type PageHeaderProps = {
  title: string;
  titleReplaceMent?: string;
  titleFirst?: boolean;
};

export default function PageHeader({
  title,
  titleReplaceMent = '',
  titleFirst = false
}: PageHeaderProps) {
  const header =
    titleFirst === false && !!titleReplaceMent ? titleReplaceMent : title;

  return (
    <>
      <div className={`${style.pageHeader} appendBottom20`}>
        <div className="makeFlex column">
          <h1 className="font22 lineHeight26 darkGreyText latoBold ">
            {header}
          </h1>
        </div>
      </div>
    </>
  );
}
